import { Component, Vue, Inject } from "vue-property-decorator";
import Vue2Filters from "vue2-filters";
import AlertMixin from "@/shared/alert/alert.mixin";
import { mixins } from "vue-class-component";
import DataConvertUtils from "@/commons/DataConvertUtils";
import LoginApi from "@/data/api/LoginApi";
import VueRecaptchaV2 from "vue-recaptcha";

@Component({
  mixins: [Vue2Filters.mixin],
  components: { VueRecaptchaV2 },
})
export default class Login extends mixins(AlertMixin) {
  private dataConvertor: DataConvertUtils = DataConvertUtils.instance;
  @Inject("loginApi") private loginApi: () => LoginApi;
  private showAuthCaptcha: any = process.env.AUTH_LOGIN_FALSE_CAPTCHA;
  private errorMessenger: boolean = true;
  private data: any = [];
  private id: any = null;
  private token: any = null;
  private isCaptcha: boolean = false;
  private showButton: boolean = false;
  private countInvalid: any = 0;

  private formLogin: any = {
    username: null,
    password: null,
  };
  constructor() {
    super();
  }

  public onVerify(token) {
    this.token = token;
    if (token) {
      //  this.isCaptcha=false;
      this.countInvalid = 0;
      this.showButton = false;
    }
  }

  public apiKeyEditor: string = process.env.LOGIN_SITE_KEY;

  public created() {
    console.log(process.env.LOGIN_SITE_KEY);
    console.log(process.env.LOGIN_SITE_DEV);
    if (this.countInvalid >= this.showAuthCaptcha) {
      this.isCaptcha = true;
    }
    this.data = this.menuDefault;

    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.checUrlUser(user);
    }
  }
  public checUrlUser(user) {
    let x = [];
    this.data.forEach((item, index) => {
      if (item.childrens.length > 0) {
        item.childrens.forEach((e, i) => {
          user.roles_detail.forEach((b) => {
            b.features.filter((c) => {
              if (c.id === e.id) {
                x.push(e);
              }
            });
          });
        });
      } else {
        user.roles_detail.forEach((d) => {
          d.features.filter((f) => {
            if (item.id === f.id) {
              x.push(item);
            }
          });
        });
      }
    });
    this.$router.push(x[0].path);
  }
  public resertInput(string: string) {
    this.formLogin[string] = null;
  }

  public resetRecaptcha() {
    this.isCaptcha = true;
    // this.$refs.recaptcha.reset();
    (this.$refs.recaptcha as any).reset();
  }

  public decodeToken(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  public submitForm() {
    if (this.formLogin.username == null || this.formLogin.username == "") {
      this.popupError("Tên đăng nhập và mật khẩu là trường bắt buộc");
      return;
    }
    if (this.formLogin.password == null || this.formLogin.password == "") {
      this.popupError("Tên đăng nhập và mật khẩu là trường bắt buộc");
      return;
    }
    // console.log("AUTH_LOGIN_FALSE_CAPTCHA", process.env.AUTH_LOGIN_FALSE_CAPTCHA);
    // console.log("SERVER_API_URL", process.env.SERVER_API_URL);

    if (this.countInvalid >= this.showAuthCaptcha) {
      this.resetRecaptcha();
      this.popupError("Tích chọn không phải người máy!");
      return;
    }
    let query: any = {
      username: this.formLogin.username.trim(),
      password: this.formLogin.password.trim(),
    };
    // this.loginApi()
    // 	.LoginV2(query)
    // 	.then((res) => {
    // 		if (res && res.success) {
    // 			this.countInvalid = 0;
    // 			this.errorMessenger = false;
    // 			let newData = JSON.parse(this.decodeToken(res.data.token).sub);
    // 			let obj = { ...newData };
    // 			obj.expiDate = new Date().setMinutes(new Date().getMinutes() + 30);
    // 			console.log("res mới", obj);
    // 			localStorage.setItem("user", JSON.stringify(obj));
    // 			localStorage.setItem("token", res.data.token);
    // 			this.$store.commit("setloginSuccess", obj);
    // 			if (obj.roles_detail) {
    // 				this.checUrlUser(obj);
    // 			}
    // 		} else {
    // 			this.countInvalid += 1;
    // 			this.popupError(res.message);
    // 			if (this.countInvalid >= this.showAuthCaptcha) {
    // 				this.isCaptcha = true;
    // 			}
    // 			this.token = null;
    // 			localStorage.removeItem("user");
    // 			localStorage.removeItem("token");
    // 			this.$store.commit("setloginFail", {});
    // 		}
    // 	})
    // 	.catch((err) => {
    // 		console.log(err);
    // 		console.log("heree");
    // 		this.countInvalid += 1;
    // 		if (this.countInvalid >= this.showAuthCaptcha) {
    // 			this.isCaptcha = true;
    // 		}
    // 		this.token = null;
    // 		this.popupError("Sai tài khoản hoặc mật khẩu");
    // 	});

    this.loginApi()
      .Login(query)
      .then(
        (res) => {
          if (res) {
            this.errorMessenger = false;
            // console.log("res cũ", res);
            let obj = res;
            let token = res.access_token;
            // console.log(token);
            obj.expiDate = new Date().setMinutes(new Date().getMinutes() + 30);
            // console.log("login user.expiDate:" + obj.expiDate);
            this.countInvalid = res.count_login_false;
            if (res.is_active) {
              if (this.countInvalid >= this.showAuthCaptcha) {
                this.isCaptcha = true;
                this.popupError("Tài khoản đăng nhập sai " + this.countInvalid + " lần!");
              } else {
                // this.isCaptcha=false;
                this.countInvalid = 0;
                localStorage.setItem("user", JSON.stringify(obj));
                localStorage.setItem("token", token);
                this.$store.commit("setloginSuccess", obj);
                if (res.roles_detail) {
                  this.checUrlUser(obj);
                } else {
                  this.token = null;
                  this.popupError("Sai tài khoản hoặc mật khẩu");
                  localStorage.removeItem("user");
                  localStorage.removeItem("token");
                  this.$store.commit("setloginFail", {});
                }
              }
            } else {
              this.popupError("Tài khoản đã khóa! Hãy liên hệ với quản trị!");
              this.token = null;
              localStorage.removeItem("user");
              localStorage.removeItem("token");
            }
          }
        },
        (err) => {
          this.countInvalid++;
          if (this.countInvalid >= this.showAuthCaptcha) {
            this.isCaptcha = true;
          }
          this.token = null;
          this.popupError("Sai tài khoản hoặc mật khẩu");
        }
      );
  }
  public popupError(message: string) {
    window.toastr.error(
      `<div class='d-flex justify-content-between'><div class='d-flex align-items-center pr-2'>${message}</div><div class='pt-1'><button type="button" class="close-toastr el-button el-button--danger el-button--small btn-toast">Đóng</button></div></div>`
    );
    window.$(".close-toastr").on("click", function () {
      // @ts-ignore
      window.toastr.clear(window.$(this).closest(".toast"), { force: true });
    });
  }
}
